export default {
  filters: {
    status: 'active',
    name: ''
  },
  member: {
    deactivating: false,
    generatingLinks: false,
    corporateInvite: {},
    enrollmentLinks: []
  },
  members: {
    active: [],
    inactive: [],
    loading: false,
    page: 0,
    totalMembers: 0
  }
}
